import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$futureOrderingLimitCateringDelivery',
  initialState,
  reducers: {
    setFutureOrderingLimitCateringDelivery(
      state,
      action: PayloadAction<number | null>,
    ) {
      return Number(action.payload ? action.payload : 0);
    },
  },
});

export const { setFutureOrderingLimitCateringDelivery } = slice.actions;
export default slice.reducer;
